import { render, staticRenderFns } from "./DynamicFormOption.vue?vue&type=template&id=6e05e65c&scoped=true&"
import script from "./DynamicFormOption.vue?vue&type=script&lang=ts&"
export * from "./DynamicFormOption.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicFormOption.vue?vue&type=style&index=0&id=6e05e65c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e05e65c",
  null
  
)

export default component.exports